import { render, staticRenderFns } from "./tab-canceled.vue?vue&type=template&id=f8cb80b4&scoped=true"
import script from "./tab-canceled.vue?vue&type=script&lang=js"
export * from "./tab-canceled.vue?vue&type=script&lang=js"
import style0 from "./tab-canceled.vue?vue&type=style&index=0&id=f8cb80b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8cb80b4",
  null
  
)

export default component.exports